import { Link } from "react-router-dom";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, updatedAt, children, testid }) {
  return (
    <main className="relative min-h-screen bg-[#0B0A0C] text-[#F4EADE]" data-testid={testid}>
      <Header />
      <section className="relative">
        <div className="absolute inset-0 hero-gradient opacity-60" aria-hidden="true" />
        <div className="absolute inset-0 grid-backdrop opacity-30" aria-hidden="true" />
        <div className="relative container-narrow pt-14 sm:pt-20 pb-10 sm:pb-14">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-[#EFE3D6]/75 hover:text-coral transition-colors"
            data-testid="legal-back-home"
          >
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#F4EADE]">
            {title}
          </h1>
          {updatedAt && (
            <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.22em] text-[#B9AFA6]">
              Last updated · {updatedAt}
            </p>
          )}
        </div>
      </section>

      <section className="section-pad border-t border-[rgba(244,234,222,0.08)]">
        <div className="container-narrow">
          <article className="prose-legal max-w-3xl text-[#EFE3D6]/85 leading-relaxed space-y-6">
            {children}
          </article>
        </div>
      </section>

      <Footer />
    </main>
  );
}

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="font-display text-xl sm:text-2xl font-semibold text-[#F4EADE] tracking-tight">
      {heading}
    </h2>
    <div className="mt-3 space-y-3 text-sm sm:text-base">{children}</div>
  </section>
);
